import script from "./FourLang.vue?vue&type=script&setup=true&lang=js"
export * from "./FourLang.vue?vue&type=script&setup=true&lang=js"

import "./FourLang.vue?vue&type=style&index=0&id=79bad0dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79bad0dd"]])

export default __exports__